import { Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormControl,
  Validators
} from '@angular/forms';
import { LoginService } from './login.service'
import { Router } from '@angular/router';
import { AuthenticationService } from '../shared/authentication.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AlarmMessageService } from '../services/alarm-message-service.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;

  incorrectDetails: boolean = false

  constructor(private loginService: LoginService,
    private router: Router,
    private authService: AuthenticationService,
    private alarmMessageService:AlarmMessageService) {
    this.loginForm = new FormGroup({
      username: new FormControl('', [Validators.required, Validators.maxLength(20)]),
      password: new FormControl('', [Validators.required, Validators.maxLength(50)])
    });
  }

  ngOnInit() {

  }

  login(): void {
    if (this.loginForm.valid) {
      this.loginService.login(this.loginForm.value).subscribe(result => {


        if (result) {
          console.log('running set user on result =>', result)
          this.authService.setUser(result);
          this.router.navigate(['/site/list/-1']);
          // this.alarmMessageService.initAlarmSocket();
        }

      }, (err: HttpErrorResponse) => {

        if(err.status == 404 || err.status == 401)
          this.incorrectDetails = true

      });
    }
  }

  xlogin(): void {
    if (this.loginForm.valid) {
      this.loginService.login(this.loginForm.value).subscribe(result => {
        this.authService.setUser(result.success);
        this.router.navigate(['/site/list/-1']);
      });
    }
  }

}
